import { useEffect } from 'react';
import Card from 'react-bootstrap/Card';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import ReportHeader from './ReportHeader';
import ReportChart from './ReportChart';
import ReportData from './ReportData';


export default function ReportViewer( { selectedReport, filters, setFilters, data, schema } ) {
    if (!selectedReport) {
        return <p className="text-muted">Please select a report from the sidebar.</p>;
    }

    return (
        <Card>
            <Card.Body>
                {/* Header */}
                <ReportHeader
                    selectedReport={selectedReport}
                    filters={filters}
                    setFilters={setFilters}
                />

                {/* Chart/Graph */}
                <Row className="my-3">
                    <ReportChart reportType={selectedReport.id} data={data} filters={filters} />
                </Row>

                {/* Data table + export */}
                <Row className="mt-3">
                    <ReportData selectedReport={selectedReport} schema={schema} data={data} />
                </Row>
            </Card.Body>
        </Card>
    );
}